var LangShop = {
    
    init: function( params ) {

        if( ! navigator.cookieEnabled ) return false;

        for (var param in params) {
            if( param in this == false && typeof params[param] == "object" ) this[param] = {};
            if( typeof params[param] == "object" ) {
                for( var key in params[param] ) {
                    this[param][key] = params[param][key];
                }
            } else {
                this[param] = params[param];
            }
        }
      
        this.localization.languages = this.localization.languages.slice(0);
        this.localization.languages.sort(function(a,b) {
          return a.lang_order - b.lang_order;
        });

        if( typeof Promise != "undefined" ) {
            var detectingUserLanguage = this.localization.detectUserLanguage();
            detectingUserLanguage.then(function(userLanguage) {
                LS.localization.defaultLang = userLanguage;
                LS.localization.init();
            });
        } else {
            LS.localization.init();
        }
      
        this.priceonhover.init();
        this.domobserver.init();      
    }, 
  
    domobserver: {

        config: {
            subtree: true, 
            characterData: true,
            childList: true 
        },
        
        replacementsRegExTest: [],
      
        escapeRegExp: function(str) {
            return str.replace(/[\-\[\]\/\(\)\*\+\?\.\\\^\$\|\:]/g, "\\$&").replace(/[{]{2}[\s]{0,}custom[\s]{0,}[}]{2}/g, "(.*?)");
        },

        pushCustomRegex: function( str, replace ) {

            var _this = LS.domobserver,
                re = /[{]{2}[\s]{0,}custom[\s]{0,}[}]{2}/;
          
            if( re.test( str ) ) {  
                str = str.replace(re, replace);
            }

            return str;
        }, 
      
        regExpTest: function( original, text, textContentCheck ) {
            
            var _this = LS.domobserver,
                before = ( ! textContentCheck ) ? "((?:[^\\w]|^|[\\s]))" : "",
                after = ( ! textContentCheck ) ? "((?:[^\\w]|$|[\\s]))" : "",
                findStr = ( ! textContentCheck ) ? _this.escapeRegExp(original) : original,
                re = new RegExp(before + findStr + after, "gi");
            
            if( re.test( text ) ) {                 
                return new RegExp(before + findStr + after, "gi");                          
            }

            return false;
        },
            
        checkForTextContent: function( text ) {

            var _this = LS.domobserver,               
                regex = false;
                
            
            if( text.trim().length == 0 ) return false;
          
            if( _this.replacementsRegExTest.length && _this.regExpTest( _this.replacementsRegExTest.join('|'), text, true ) ) {
                regex = true;  
            }
          
            return regex;
        },

        parseNodes: function( elem ) {

            var _this = LS.domobserver;
            if (elem) {
                for ( var nodes = elem.childNodes, i = nodes.length; i--; ) {
                    var node = nodes[i],
                        nodeType = node.nodeType,
                        nodeTag = node.tagName;
                  
                    if( nodeTag == "SCRIPT" || nodeTag == "STYLE" ) continue;

                    if (nodeType == 3) {
                        _this.replaceNode( node, 'data' );
                    } else if ( nodeTag == "INPUT" || nodeTag == "TEXTAREA" ) {
                        _this.replaceElementNode( node );
                    } else if ( (nodeType == 1 || nodeType == 9 || nodeType == 11) && node.childNodes.length && node.innerHTML.trim().length ) {
                        if( _this.checkForTextContent( node.outerHTML ) ) _this.parseNodes( node );
                    }
                }
            }        
        },
      
        replaceNode: function( node, key ) {

            var _this = LS.domobserver,
                currentLang = LS.localization.currentLang; 

            if( typeof node == "object" && key in node && node[key].trim().length ) {
                
                _this.globalReplace.forEach(function(replacement){
                    
                    if( currentLang in replacement.translated && replacement.translated[currentLang] ) {

                        var match,
                            translated = replacement.translated[currentLang],
                            re = _this.regExpTest( replacement.original.text, node[key] );
                        
                        if( re ) { 
                            
                            do {
                                match = re.exec(node[key]);

                                if (match && match.length > 2) {

                                    for (var i = 2; i < (match.length - 1); i++) {
                                        translated = _this.pushCustomRegex( translated, match[i] );
                                    }
                                    node[key] = node[key].replace(match[0], match[1] + translated + match[(match.length - 1)]);    
                                }
                                    
                            } while (match);                       
                        }
                    }
                });            
            }
        },
        
        replaceElementNode: function( node ) {

            var _this = LS.domobserver;                 
          
            if( ! node.type ) return;
            
            switch( node.type.toLowerCase() ) {
                case "submit":
                case "button":
                case "reset":
                    _this.replaceNode( node, 'value' );
                    break;
                
                case "text":
                case "email":
                case "number":
                case "textarea":
                    _this.replaceNode( node, 'placeholder' );
                    break;
            }
        },
      
        parseGlobalReplaceData: function(str) {

            var translateObject = [];
            var ls_translate_objects = str.split(':ELEMENT:');
          
            ls_translate_objects.forEach(function(ls_translate_object){
                var ls_translate_data_object = ls_translate_object.split(":TRANSLATED:"),
                    ls_translate_original = ls_translate_data_object[0].split(":ORIGINAL:"),
                    before = ( typeof ls_translate_original[0] != "undefined" ) ? ls_translate_original[0] : "",
                    text = ( typeof ls_translate_original[1] != "undefined" ) ? ls_translate_original[1] : "",
                    after = ( typeof ls_translate_original[2] != "undefined" ) ? ls_translate_original[2] : "",
                    translated = {};

                if( typeof ls_translate_data_object[1] != "undefined" && text.trim() && before.trim() && after.trim() ) {
                    var ls_translated_languages = ls_translate_data_object[1].split(":LANG:");
                    ls_translated_languages.forEach(function(ls_translated_language){
                        var ls_language_data = ls_translated_language.split(":TEXT:");
                        translated[ls_language_data[0]] = ( typeof ls_language_data[1] != "undefined" ) ? ls_language_data[1] : "";
                    });

                    translateObject.push({
                        original: {
                            before: before,
                            text: text,
                            after: after
                        },
                        translated: translated
                    });
                }
            });
          
            return translateObject;
        },
      

        init: function() {

            var _this = LS.domobserver,
                currentLang = LS.localization.currentLang,
                MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
            
            _this.globalReplace = _this.parseGlobalReplaceData(_this.globalReplaceData);
          
            if( ! _this.globalReplace )
                return false;

            _this.globalReplace.forEach(function(replacement){
                if( currentLang in replacement.translated && replacement.translated[currentLang] ) {                  
                    _this.replacementsRegExTest.push("(" + _this.escapeRegExp(replacement.original.before) + "[\\s]{0,}" + _this.escapeRegExp(replacement.original.text) + "[\\s]{0,}" + _this.escapeRegExp(replacement.original.after) + ")");
                }
            });
            
            if( _this.replacementsRegExTest.length == 0 )
                return false;
            
            document.addEventListener("DOMContentLoaded", function(){
                
                if( _this.dynamicTranslateDomLoaded == "1" && _this.checkForTextContent( document.body.innerHTML ) ) {
                    _this.parseNodes( document.body );
                }
                
                if( _this.dynamicTranslateDomChanged == "1" ) {
                    
                    var domChanedDelay = 0,
                        globalMutations = [];

                    var observer = new MutationObserver(function(mutations, observer) { 
                        
                        clearTimeout(domChanedDelay);
                        globalMutations = globalMutations.concat(mutations);
                        
                        domChanedDelay = setTimeout(function(){
                          
                            observer.disconnect();
                        
                            globalMutations.forEach(function(mutation){ 

                                if( mutation.type == "childList" ) {

                                    if( _this.checkForTextContent( mutation.target.outerHTML ) ) {
                                        _this.parseNodes( mutation.target );
                                    }                            
                                }

                                if( mutation.type == "characterData" ) {
                                    _this.replaceNode( mutation.target, 'data' );
                                }

                            });
                          
                            globalMutations = [];
                            observer.observe(document.body, _this.config); 

                        }, 0);
                            
                    }); 

                    observer.observe(document.body, _this.config);
                }    
            });                
        }
    },
    
    localization: {
      
        getLanguageByCountry: function( countryCode ) {
            var _this = LS.localization;

            if( typeof _this.countriesLangDepends == 'object'  ) {
                for( var lang in _this.countriesLangDepends ) {
                    var needle = _this.languages.map(function(x) {return x.lang_id; }).indexOf(lang);
                    if(needle >= 0) {
                        if( countryCode in _this.countriesLangDepends[lang] && _this.countriesLangDepends[lang][countryCode] == 'true' ) return lang;
                    }                     
                }
            }
            return _this.defaultLang;
        },
      
        detectUserLanguage: function() {
            
            var _this = LS.localization;
          
            return new Promise(function(resolve, reject) {            
            
                if( _this.detectingLanguage == "browser" && ! _this.languageInCart && _this.browserLangDepends ) {

                    var detectBrowserLang = navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage,
                        userLangObj = detectBrowserLang.split('-'),
                        userLang = userLangObj[0].toLowerCase();
                  
                    if( typeof _this.browserLangDepends == 'object'  ) {
                        for( var lang in _this.browserLangDepends ) {
                            var needle = _this.languages.map(function(x) {return x.lang_id; }).indexOf(lang);
                            if(needle >= 0) {
                                if( _this.browserLangDepends[lang].indexOf(userLang) >= 0 ) resolve(lang);
                            }
                        }
                    }

                    resolve(_this.defaultLang);

                } else if( _this.detectingLanguage == "geolocation" && ! _this.languageInCart && _this.countriesLangDepends  ) {

                    var xhttp = new XMLHttpRequest();
                        xhttp.open("GET", "https://freegeoip.net/json/", true);
                        xhttp.onload = function (e) {
                            if (xhttp.readyState === 4) {
                                if (xhttp.status === 200) {
                                    var userInfo = JSON.parse(xhttp.responseText);
                                    if( typeof userInfo == 'object' && 'country_code' in userInfo ) {
                                        resolve(_this.getLanguageByCountry(userInfo.country_code.toLowerCase()));
                                    } else {
                                        resolve(_this.defaultLang);
                                    }
                                } else {
                                    resolve(_this.defaultLang);
                                }
                            }
                        };
                        xhttp.onerror = function (e) {
                            resolve(_this.defaultLang);
                        };
                        xhttp.send(null);                                    
                } else {
                    resolve(_this.defaultLang);
                }
                
            });
        },
      
        variable: function( varName, defaultVal, varRaplace, replaceTo ) {

            var _this = LS.localization;

            if( _this.localesJson == null) {
              return defaultVal;
            }           
            
            var locale = JSON.parse( _this.localesJson ),
                objArr = varName.split('.');
            
            if( typeof locale != "object" ) {
                return defaultVal;
            }

            var localeValue = "";
            for( var i = 0; i < objArr.length; i++ ) {  
                if( localeValue === undefined ) return defaultVal;
                localeValue = ( i == 0 ) ? locale[objArr[i]] : localeValue[objArr[i]];              
            }
            
            return ( localeValue != "" && localeValue != undefined ) ? _this.patternReplace(localeValue, varRaplace, replaceTo) : defaultVal;
        },
          
        formatMoney: function(cents, format) {
          
            var _this = LS.localization,
                moneyFormat = '${{amount}}',
                shop_currency = _this.shop_currency;
          
            if (typeof cents === 'string') {
                var spanRegex = /<span[\s\S]*?>[\s\S]*?<\/span>/;
                if( cents.match(spanRegex) ) {
                    return cents;

                } else {
                    cents = cents.replace('.', '');
                }
            }

            var value = '',
                placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
                formatString = (format || moneyFormat);
          
            function formatWithDelimiters(number, precision, thousands, decimal) {

                precision = precision || 2;
                thousands = thousands || ',';
                decimal = decimal || '.';

                if (isNaN(number) || number == null) {
                    return 0;
                }
                number = (number / 100.0).toFixed(precision);

                var parts = number.split('.'),
                    dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                    centsAmount = parts[1] ? (decimal + parts[1]) : '';

                return dollarsAmount + centsAmount;
            }
            
            var span = "",
                ls_currencies = _this.currencies;

            if( _this.currSwitcherType && _this.currSwitcherType != "disabled" && ls_currencies != null && typeof ls_currencies == "object" && _this.currency && ! isNaN(cents) ) {
               
                var needle_old = ls_currencies.map(function(x) {return x.currId; }).indexOf(shop_currency),
                    needle_new = ls_currencies.map(function(x) {return x.currId; }).indexOf(_this.currency);

                if( needle_old >= 0 && needle_new >= 0 ) {
                    var currency_rate_old = parseFloat(ls_currencies[needle_old].rate),
                        currency_rate_new = parseFloat(ls_currencies[needle_new].rate),
                        originalCents = cents;

                    cents = cents / currency_rate_old * currency_rate_new;
                    formatString = ls_currencies[needle_new].money_format;
                  
                    span += "<span class='LS_converted_currencies " + ( ( _this.defaultCurr != _this.currency && _this.defaultCurrOnHover == "1" ) ? "LS_show_on_hover" : "" ) + "'";                  
                    for(var index in ls_currencies) {
                        var anotherCents = originalCents / currency_rate_old * ls_currencies[index].rate,
                            anotherFormat = ls_currencies[index].money_format;
                      
                        switch (anotherFormat.match(placeholderRegex)[1]) {
                            case 'amount':
                                var formatedDelimeters = formatWithDelimiters(anotherCents, 2);
                                break;
                            case 'amount_no_decimals':
                                var formatedDelimeters = formatWithDelimiters(anotherCents, 0);
                                break;
                            case 'amount_with_comma_separator':
                                var formatedDelimeters = formatWithDelimiters(anotherCents, 2, '.', ',');
                                break;
                            case 'amount_no_decimals_with_comma_separator':
                                var formatedDelimeters = formatWithDelimiters(anotherCents, 0, '.', ',');
                                break;
                            case 'amount_no_decimals_with_space_separator':
                                var formatedDelimeters = formatWithDelimiters(anotherCents, 0, ' ');
                                break;
                        }
                        
                        var resultFormated = anotherFormat.replace(placeholderRegex, formatedDelimeters);
                        if( _this.defaultCurr == ls_currencies[index].currId ) span += " data-default='" + _this.escape(resultFormated) + "'"; 
                        span += " data-" + ls_currencies[index].currId + "='" + _this.escape(resultFormated) + "'";                        
                    }
                    span += ">&nbsp;</span>";
                }
                
            }

            if( formatString.match(placeholderRegex) ) {
                switch (formatString.match(placeholderRegex)[1]) {
                    case 'amount':
                        value = formatWithDelimiters(cents, 2);
                        break;
                    case 'amount_no_decimals':
                        value = formatWithDelimiters(cents, 0);
                        break;
                    case 'amount_with_comma_separator':
                        value = formatWithDelimiters(cents, 2, '.', ',');
                        break;
                    case 'amount_no_decimals_with_comma_separator':
                        value = formatWithDelimiters(cents, 0, '.', ',');
                        break;
                    case 'amount_no_decimals_with_space_separator':
                        value = formatWithDelimiters(cents, 0, ' ');
                        break;
                }
            } else {
                return formatString;
            }                
          
            return formatString.replace(placeholderRegex, value) + span;
        },
          
        options: function(params) {

            var _this = LS.localization,
                appendTo = document.getElementById(params.element);
          
            if( typeof params.options != "object" || appendTo == undefined ) {
                return false;
            }

            var options = params.options,
                product = params.product;

            if( typeof product == "object" && "error" in product == false  && options ) {
            
                for(option in options) {
                    
                    var elements = [];
                    if( typeof options[option].inputs == "object" && Object.keys(options[option].inputs).length !== 0 ) {
                        
                        for(input in options[option].inputs) {
                            if( _this.currentLang in options[option].inputs[input].name && options[option].inputs[input].name[_this.currentLang] ) {
                                var inputCollection = _this.createOptions(options[option].inputs[input]);
                                if( 'wrapper' in options[option].inputs[input] && options[option].inputs[input].wrapper != "none" ) {
                                    var wrapper = document.createElement(options[option].inputs[input].wrapper);
                                    if( 'wrapper_class' in options[option].inputs[input] ) {
                                        wrapper.setAttribute("class", _this.escape(options[option].inputs[input].wrapper_class));
                                    }
                                    [].forEach.call(inputCollection, function(el) {
                                        wrapper.appendChild(el);
                                    });
                                    elements.push(wrapper);
                                } else {
                                    elements = elements.concat(inputCollection);
                                }
                            }
                        }

                        if( typeof options[option].rules == "object" && Object.keys(options[option].rules).length !== 0 ) {
                            var match = ( "match" in options[option] ) ? options[option].match : "or";
                            if( ! _this.checkRule(product, options[option].rules, match) ) {
                                continue;
                            }
                        }
                      
                        [].forEach.call(elements, function(el) {
                            appendTo.appendChild(el);
                        });
                    }                
                }    
            }     
        },
          
        checkRule: function(product, rules, match) {
          
            var _this = LS.localization,
                matchRules = true;
          
            for( rule in rules ) {
  
                switch(rules[rule].column) {
                    case "title":
                        if ( _this.checkRelation(rules[rule].relation, rules[rule].condition.toLowerCase(), product.title.toLowerCase()) ) {
                            if( match == "or" ) return true; 
                        } else {
                            matchRules = false;
                        } 
                    
                        break;
                    
                    case "type":
                        if ( _this.checkRelation(rules[rule].relation, rules[rule].condition.toLowerCase(), product.type.toLowerCase()) ) {
                            if( match == "or" ) return true; 
                        } else {
                            matchRules = false;
                        }
                    
                        break;
                    
                    case "vendor":
                        if ( _this.checkRelation(rules[rule].relation, rules[rule].condition.toLowerCase(), product.vendor.toLowerCase()) ) {
                            if( match == "or") return true; 
                        } else {
                            matchRules = false;
                        }
                    
                        break;
                    
                    case "variant_price":
                        if( product.variants.length ) {
                            var variant_find = false;
                            product.variants.forEach(function(el){
                                var price = ( parseFloat( rules[rule].condition ) !== NaN ) ? parseFloat( rules[rule].condition ) * 100 : null;
                                if( price !== null && _this.checkRelation(rules[rule].relation, price, el.price) ) variant_find = true;
                            });
                            if(variant_find) {
                                if( match == "or" ) return true; 
                            } else {
                                matchRules = false; 
                            }
                        } else {
                            matchRules = false;
                        }
                    
                        break;
                    
                    case "tag":
                        if( product.tags.length ) {
                            var tags_find = false;
                            product.tags.forEach(function(el){
                                if( _this.checkRelation(rules[rule].relation, rules[rule].condition.toLowerCase(), el.toLowerCase()) ) tags_find = true;
                            });
                            if(tags_find) {
                                if( match == "or" ) return true; 
                            } else {
                                matchRules = false;
                            }
                        } else {
                            matchRules = false;
                        }
                    
                        break;
                    
                    case "variant_compare_at_price":
                        if( product.variants.length ) {
                            var variant_find = false;
                            var price = ( parseFloat( rules[rule].condition ) !== NaN ) ? parseFloat( rules[rule].condition ) * 100 : null;
                            product.variants.forEach(function(el){                                
                                if( price !== null && _this.checkRelation(rules[rule].relation, price, el.compare_at_price) ) variant_find = true;
                            });
                          
                            if( rules[rule].relation == "not_equals" && match == "and" ) {
                                product.variants.forEach(function(el){
                                    if( el.compare_at_price == price ) {
                                        variant_find = false;
                                    }
                                });
                            }
                            
                            if(variant_find) {
                                if( match == "or" ) return true;
                            } else {
                                matchRules = false;
                            }
                        } else {
                            matchRules = false;
                        }
                    
                        break;
                    
                    case "variant_weight":
                        if( product.variants.length ) {
                            var variant_find = false;
                            var weight = ( parseFloat( rules[rule].condition ) !== NaN ) ? parseFloat( rules[rule].condition ) * 1000 : null;
                            product.variants.forEach(function(el){                                
                                if( weight !== null && _this.checkRelation(rules[rule].relation, weight, el.weight) ) variant_find = true;
                            });
                          
                            if( rules[rule].relation == "not_equals" && match == "and" ) {
                                product.variants.forEach(function(el){
                                    if( el.weight == weight ) {
                                        variant_find = false;
                                    }
                                });
                            }
                            
                            if(variant_find) {
                                if( match == "or" ) return true;
                            } else {
                                matchRules = false;
                            }
                        } else {
                            matchRules = false;
                        }
                    
                        break;
                    
                    case "variant_inventory":
                        if( product.variants.length ) {
                            var variant_find = false;
                            var inventory = ( parseInt( rules[rule].condition, 10 ) !== NaN ) ? parseInt( rules[rule].condition, 10 ) : null;
                            product.variants.forEach(function(el){                                
                                if( el.inventory_management == "shopify" && inventory !== null && _this.checkRelation(rules[rule].relation, inventory, el.inventory_quantity) ) variant_find = true;
                            });
                            
                            if(variant_find) {
                                if( match == "or" ) return true;
                            } else {
                                matchRules = false;
                            }
                        } else {
                            matchRules = false;
                        }
                    
                        break;
                    
                    case "variant_title":
                        if( product.variants.length ) {
                            var variant_find = false;
                            product.variants.forEach(function(el){
                                if( el.title != "Default Title" && _this.checkRelation(rules[rule].relation, rules[rule].condition.toLowerCase(), el.title.toLowerCase()) ) variant_find = true;
                            });
                            
                            if( (rules[rule].relation == "not_contains" || rules[rule].relation == "not_equals") && match == "and" ) {
                                product.variants.forEach(function(el){
                                    if( el.title != "Default Title" && el.title.toLowerCase().indexOf(rules[rule].condition.toLowerCase()) >= 0 ) {
                                        variant_find = false;
                                    }
                                });
                            }
                          
                            if(variant_find) {                                  
                                if( match == "or" ) return true;
                            } else {
                                matchRules = false;
                            }                          
                        } else {
                            matchRules = false;
                        }
                    
                        break;
                }
            }

            return ( match == "or" ) ? false : matchRules;
        },
          
        checkRelation: function(relation, condition, param) {
            
            if( condition === "" || param === "" || param === null ) return false;

            switch(relation) {
                case "equals":
                    return param == condition;
                
                case "not_equals":
                    return param != condition;
                
                case "greater_than":
                    return param > condition;
                
                case "less_than":
                    return param < condition;
                
                case "starts_with":
                    return param.indexOf(condition) === 0;
                
                case "ends_with":
                    return param.indexOf(condition, param.length - condition.length) !== -1;
                
                case "contains":
                    return param.indexOf(condition) >= 0;
                
                case "not_contains":
                    return param.indexOf(condition) < 0;
            }
                
            return false;
        },
          
        createOptions: function( object ) {

            var _this = LS.localization;
            var elements = [];
            var id = "Property-" + (Math.floor(Math.random() * (9999 - 1111)) + 1111);

            if(_this.currentLang in object.label && object.label[_this.currentLang] ) {
                var label = document.createElement("LABEL");
                    label.setAttribute("for", id);
                    label.innerHTML = object.label[_this.currentLang];
                if( 'label_class' in object ) label.setAttribute("class", _this.escape(object.label_class));
              
                elements.push(label);
            }
          
            switch(object.type) {
                case "text":
                    var input = document.createElement("INPUT");
                        input.setAttribute("type", 'text');
                        input.name = "properties[" + _this.escape(object.name[_this.currentLang]) + "]";
                        input.id = id;
                    if( 'input_class' in object ) input.setAttribute("class", _this.escape(object.input_class));
                    if( 'required' in object && object.required == "1" ) input.setAttribute("required", "");
                    if( 'default' in object && _this.currentLang in object.default ) input.value = _this.escape(object.default[_this.currentLang]);
                    if( 'placeholder' in object && _this.currentLang in object.placeholder ) input.placeholder = _this.escape(object.placeholder[_this.currentLang]);
                
                    elements.push(input);
                    break;
                
                case "textarea":
                    var textarea = document.createElement("TEXTAREA");
                        textarea.name = "properties[" + _this.escape(object.name[_this.currentLang]) + "]";
                        textarea.id = id;
                    if( 'input_class' in object ) textarea.setAttribute("class", _this.escape(object.input_class));
                    if( 'required' in object && object.required == "1" ) textarea.setAttribute("required", "");
                    if( 'default' in object && _this.currentLang in object.default ) textarea.value = _this.escape(object.default[_this.currentLang]);
                    if( 'placeholder' in object && _this.currentLang in object.placeholder ) textarea.placeholder = _this.escape(object.placeholder[_this.currentLang]);
                
                    elements.push(textarea);
                    break;
                
                case "number":
                    var input = document.createElement("INPUT");
                        input.setAttribute("type", 'number');
                        input.name = "properties[" + _this.escape(object.name[_this.currentLang]) + "]";
                        input.id = id;
                    if( 'input_class' in object ) input.setAttribute("class", _this.escape(object.input_class));
                    if( 'required' in object && object.required == "1" ) input.setAttribute("required", "");
                    if( 'default' in object && _this.currentLang in object.default ) input.value = _this.escape(object.default[_this.currentLang]);
                    if( 'placeholder' in object && _this.currentLang in object.placeholder ) input.placeholder = _this.escape(object.placeholder[_this.currentLang]);
                
                    elements.push(input);
                    break;
                
                case "radio":
                    if(object.values.length) {
                        var i = 0;
                        object.values.forEach(function(el) {
                            var lang = ( _this.currentLang in el ) ? _this.currentLang : ( (_this.defaultLang in el) ? _this.defaultLang : null );
                            if( lang ) {
                                var id = "Property-" + (Math.floor(Math.random() * (9999 - 1111)) + 1111);
                                var label = document.createElement("LABEL");
                                    label.setAttribute('for', id);
                                    label.innerHTML = "<input id='" + id + "' type='radio' value='" + _this.escape(el[lang]) + "' name='properties[" + _this.escape(object.name[_this.currentLang]) + "]' " + (( i == 0 ) ? "checked='checked'" : "") + " " + ( ( 'required' in object && object.required == "1" && i == 0 ) ? "required=''" : "" ) + " >" + _this.escape(el[lang]);
                                if( 'input_class' in object ) label.setAttribute("class", _this.escape(object.input_class));
                                elements.push(label);
                                i++;
                            }
                            
                        });
                    }
                    break;
                
                case "checkbox":
                    if(object.values.length) {
                        var hidden = document.createElement("INPUT");
                            hidden.setAttribute("type", 'hidden');
                            hidden.name = "properties[" + _this.escape(object.name[_this.currentLang]) + "]";
                            hidden.id = "Property-" + (Math.floor(Math.random() * (9999 - 1111)) + 1111) + "-hidden";
                        
                        elements.push(hidden);
                        object.values.forEach(function(el) {
                            var lang = ( _this.currentLang in el ) ? _this.currentLang : ( (_this.defaultLang in el) ? _this.defaultLang : null );
                            if( lang ) {
                                var id = "Property-" + (Math.floor(Math.random() * (9999 - 1111)) + 1111);
                                var label = document.createElement("LABEL");
                                    label.setAttribute('for', id);
                                    label.innerHTML = "<input class='" + hidden.id + "' id='" + id + "' type='checkbox' value='" + _this.escape(el[lang]) + "'>" + _this.escape(el[lang]);
                                    label.querySelector('input[type=checkbox]').addEventListener("change", function(event){
                                        hidden.value = "";
                                        [].forEach.call(document.querySelectorAll("." + hidden.id ), function(el) {                                            
                                            if(el.checked) {
                                                
                                                hidden.value += ', ' + el.value;
                                            }
                                        });
                                        if(hidden.value) hidden.value = hidden.value.substring(2);                                     
                                    });
                                    if( 'input_class' in object ) label.setAttribute("class", _this.escape(object.input_class));
                              
                                elements.push(label);
                            }
                            
                        });
                    }
                    break;
                
                case "select":
                    if(object.values.length) {
                        var i = 0;
                        var select = document.createElement("SELECT");
                            select.name = "properties[" + _this.escape(object.name[_this.currentLang]) + "]";
                            select.id = id;
                        if( 'input_class' in object ) select.setAttribute("class", _this.escape(object.input_class));
                        if( 'required' in object && object.required == "1" ) select.setAttribute("required", "");
                      
                        object.values.forEach(function(el) {
                            var lang = ( _this.currentLang in el ) ? _this.currentLang : ( (_this.defaultLang in el) ? _this.defaultLang : null );
                            if( lang ) {

                                var options = document.createElement("OPTION");
                                    options.text = _this.escape(el[lang]);
                                    options.value = _this.escape(el[lang]);
                                    
                                select.add(options, null);
                                i++;
                            }
                            
                        });
                        
                        if(i) elements.push(select);
                    }
                    break;
            }
          
            return elements;
        },
        
        escape: function(str) {
            return str
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/\"/g, '&quot;')
                .replace(/\'/g, '&#39;')
                .trim();  
        },
          
        patternReplace: function( str, varRaplace, replaceTo ) {

            var re = /[\{\{]{2}[a-zA-Z0-9._\s]{1,}[\}\}]{2}/i;

            if( re.test( str ) && varRaplace != "" && replaceTo != "" ) {  
                return str.replace(re, replaceTo);
            }

            return str;
        },
        getSearchParameters: function( string ) {

            var _this = LS.localization,
                prmstr = ( string ) ? string : window.location.search.substr(1);

            return prmstr != null && prmstr != "" ? _this.transformToAssocArray(prmstr) : {};
        },
        transformToAssocArray: function( prmstr ) {

            var params = {},
                prmarr = prmstr.split("&");

            for ( var i = 0; i < prmarr.length; i++) {
                var tmparr = prmarr[i].split("=");
                params[tmparr[0]] = tmparr[1];
            }

            return params;
        },
        cartLangUpdate: function( lang, reload, curr ) {

            var _this = LS.localization,
                attributes = {};

            if( lang ) {
                attributes['LS_language'] = lang; 
                _this.languageInCart = lang;                        
            }

            if( curr ) attributes['LS_currency'] = curr;
          
            var xhttp = new XMLHttpRequest();
            xhttp.onreadystatechange = function() {
                if (xhttp.readyState == 4 && xhttp.status == 200) {
                    if( _this.urlModifyType != 'domains' ) {
                        if( lang && reload ) location.reload();
                    }
                }
            };              
            xhttp.open("POST", "/cart/update.js", true);
            xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            xhttp.send(JSON.stringify({attributes: attributes }));           
        },
          
        checkUrlParams: function() {
            
            var _this = LS.localization,
                cLang = _this.getCookie('ls_lang');

            if( cLang != "" && _this.languages.map(function(x) {return x.lang_id; }).indexOf(cLang) < 0 ) cLang = "";

            _this.urlParams = _this.getSearchParameters(); 
              
            var themeCustomizer = ( ( '_sc' in _this.urlParams && _this.urlParams['_sc'] == 1 ) || 'preview_theme_id' in _this.urlParams) ? true : false;

            if( _this.urlModify === '1' && themeCustomizer == false ) {
                
                if( _this.getUrlPrefix in _this.urlParams && _this.urlModifyType == "get" ) {
                    
                    for( var i = 0; i < _this.languages.length; i++ ) {
                        if( _this.languages[i].lang_id == _this.urlParams[_this.getUrlPrefix] && ( _this.urlModifyType == "get" || _this.urlHash == "" ) ) {
                            return _this.urlParams[_this.getUrlPrefix];
                        }
                    }   
                  
                    LS.location = LS.location.replace(_this.getUrlPrefix + "=" + _this.urlParams[_this.getUrlPrefix], _this.getUrlPrefix + "=" + _this.defaultLang) 
                    window.history.replaceState(null, null, LS.location); 
                    
                } else if( _this.urlModifyType == "hash" ) {
                    
                    for( var i = 0; i < _this.languages.length; i++ ) {
                        if( _this.urlHash == _this.languages[i].lang_id ) {
                            return _this.urlHash;
                        }
                    } 

                    if(location.hash) location.hash = _this.currentLang;
                  
                } else if( _this.urlModifyType == "domains" && _this.mdomains ) {
                    
                    if( cLang != "" && ! _this.languageInCart ) {
                        _this.languageInCart = cLang;
                        _this.cartLangUpdate( cLang, false, _this.getCookie('ls_curr') );
                    }

                    var checkReferer = true,
                        mdomains = JSON.parse(_this.mdomains),
                        referrer = (document.referrer) ? new URL(document.referrer).hostname : '';
                    
                    if( mdomains ) {

                        //Check refferer for detecting switching language with detectingLanguage == "browser" or detectingLanguage == "geolocation"
                        for( index in mdomains ) {
                            var mdomain = mdomains[index].split(',');
                            if( mdomain.indexOf(referrer) >= 0 || referrer.indexOf('langshop.') >= 0 ) {
                                checkReferer = false;
                            }
                        }

                        for( index in mdomains ) {
                            var mdomain = mdomains[index].split(',');
                            if( mdomain.indexOf(window.location.host) >= 0 ) { 
                                if( ! _this.languageInCart && ( _this.detectingLanguage == "browser" || _this.detectingLanguage == "geolocation" ) && checkReferer ) {
                                    if( index == _this.defaultLang ) return index;
                                } else {
                                    return index;
                                }  
                            }
                        }

                        if( _this.defaultLang in mdomains ) {
                            var mdomain = mdomains[_this.defaultLang].split(','),
                                url = window.location;
                                url = url.toString();
                                url = url.replace(window.location.host, mdomain[0]);

                            window.location = url; 
                        }                        
                    }
                }
            }

            if( cLang != "" ) {
                return cLang;
            }
          
            return _this.defaultLang;
        },

        setCookie: function(cname, cvalue, exdays) {

            var expires = "";
            if( exdays != undefined ) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays*24*60*60*1000));
                var expires = "; expires="+d.toUTCString();
            }
            
            document.cookie = cname + "=" + cvalue + expires + "; path=/";
        },
        getCookie: function(cname) {

            var name = cname + "=",
                ca = document.cookie.split(';');

            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length,c.length);
                }
            }

            return "";
        },
        
        getClickAncestor: function(node, tagName) {

            tagName = tagName.toUpperCase();
            while (node) {
                if (node.nodeType == 1 && node.nodeName == tagName) {
                    return node;
                }
                node = node.parentNode;
            }

            return null;
        },
          
        styleGenerator: function( parentId, switcherStyle, switcherType, styleObj ) {
            
          if( ! switcherStyle ) switcherStyle = "ls-style-theme-a";
          
          if( switcherStyle != '1' || switcherType == "select" ) { 
                var css = "",
                    head = document.head || document.getElementsByTagName('head')[0],
                    style = document.createElement('style'),
                    parentId = "#" + parentId;
                
                switch(styleObj.position_type) {
                    case "fixed-right-bottom":
                        css += parentId + " { top: auto!important; position: fixed; bottom:" + styleObj.offset_bottom + styleObj.offset_dimension + ";right:" + styleObj.offset_right + styleObj.offset_dimension + "; }";
                        break;
                    
                    case "fixed-left-bottom":
                        css += parentId + " { top: auto!important; position: fixed; bottom:" + styleObj.offset_bottom + styleObj.offset_dimension + ";left:" + styleObj.offset_left + styleObj.offset_dimension + "; }";
                        break;
                    
                    case "fixed-right-top":
                        css += parentId + " { position: fixed; top:" + styleObj.offset_top + styleObj.offset_dimension + ";right:" + styleObj.offset_right + styleObj.offset_dimension + "; }";
                        break;
                    
                    case "fixed-left-top":
                        css += parentId + " { position: fixed; top:" + styleObj.offset_top + styleObj.offset_dimension + ";left:" + styleObj.offset_left + styleObj.offset_dimension + "; }";
                        break;
                }
            
                css += parentId + " ul { color:" + styleObj.main_font_color + ";";
                css += ( switcherStyle != "ls-style-theme-b" ) ? "background-color:" + styleObj.main_bg_color + ";}" : "}";
            
                if( switcherType == "li-vertical-non-flags" || switcherType == "li-vertical-non-text" || switcherType == "li-vertical") {
                    switch(styleObj.dropdown_direction) {
                        case "fixed-right-bottom":
                            css += parentId + " ul { top: 100%;bottom: auto;right: auto;left: 0;-webkit-transform-origin: -50% 0;transform-origin: -50% 0; }";
                            break;

                        case "fixed-left-bottom":
                            css += parentId + " ul { top: 100%;bottom: auto;right: 0;left: auto;-webkit-transform-origin: 150% 0;transform-origin: 150% 0; }";
                            break;

                        case "fixed-right-top":
                            css += parentId + " ul { top: auto;bottom: 100%;right: auto;left: 0;-webkit-transform-origin: 0 150%;transform-origin: 0 150%; }";
                            break;

                        case "fixed-left-top":
                            css += parentId + " ul { top: auto;bottom: 100%;right: 0;left: auto;-webkit-transform-origin: 100% 150%;transform-origin: 100% 150%; }";
                            break;
                    }
                }
                
                css += parentId + " ul li:not(.ls-curr-switcher-active):not(.ls-lang-switcher-active) { border: 1px solid " + styleObj.main_border_color + ";";
                css += ( switcherStyle == "ls-style-theme-b" ) ? "background-color:" + styleObj.main_bg_color + ";}" : "}";
                
                css += parentId + " ul li:not(.ls-curr-switcher-active):not(.ls-lang-switcher-active):hover { border: 1px solid " + styleObj.hover_main_border_color + ";color:" + styleObj.hover_main_font_color + ";";
                css += "background-color:" + styleObj.hover_main_bg_color + ";}";
                
                css += parentId + " .ls-curr-switcher-active," + parentId + " .ls-lang-switcher-active { ";
                css += "background-color:" + styleObj.active_bg_color + ";border: 1px solid " + styleObj.active_border_color + ";color:" + styleObj.active_font_color + ";";
                css += "}";
                
                css += parentId + " .ls-curr-switcher-active:hover," + parentId + " .ls-lang-switcher-active:hover { ";
                css += "background-color:" + styleObj.hover_active_bg_color + ";border: 1px solid " + styleObj.hover_active_border_color + ";color:" + styleObj.hover_active_font_color + ";";
                css += "}";
                
                css += parentId + " .ls-curr-switcher-active::after," + parentId + " .ls-lang-switcher-active::after { ";
                css += "border-bottom: 2px solid " + styleObj.hover_active_font_color + ";border-right: 2px solid " + styleObj.hover_active_font_color + ";";
                css += "}";
            
                css += parentId + " .ls-curr-switcher-active:hover::after," + parentId + " .ls-lang-switcher-active::after { ";
                css += "border-bottom: 2px solid " + styleObj.active_font_color + ";border-right: 2px solid " + styleObj.active_font_color + ";";
                css += "}";
                
                style.type = 'text/css';
                if (style.styleSheet){
                    style.styleSheet.cssText = css;
                } else {
                    style.appendChild(document.createTextNode(css));
                }

                head.appendChild(style);
            }      
        },
          
        init: function() {

            var _this = LS.localization; 
           
            var checkUrl = _this.checkUrlParams();
            if( checkUrl != _this.currentLang ) {
                _this.setCookie('ls_lang', checkUrl, 30);
                _this.cartLangUpdate( checkUrl, true, _this.getCookie('ls_curr') );
            }
            
            if( ! _this.languageInCart ) {
                _this.cartLangUpdate( checkUrl, true, _this.getCookie('ls_curr') );
            } else if( _this.urlModifyType == "domains" && _this.mdomains ) {
                if( _this.currentLang != _this.languageInCart ){
                    _this.cartLangUpdate( _this.currentLang, false, _this.getCookie('ls_curr') );
                }
            } 
          
            if( _this.urlModify === '1') {
        
                if( _this.urlModifyType == 'hash' ){
                    if( location.hash == "" && _this.currentLang == _this.getCookie('ls_lang') ) {
                        location.hash = _this.currentLang;
                    }
                } else if( _this.urlModifyType == 'get' ) {

                    var get_pref = _this.getUrlPrefix,
                        replaceHref = window.location.protocol + "//" + window.location.hostname + window.location.pathname + window.location.search;

                    if( get_pref in _this.urlParams == false && _this.currentLang == _this.getCookie('ls_lang') ) {
                        if( replaceHref.indexOf('?') < 0 ) {
                            window.history.replaceState(null, null, replaceHref + "?" + get_pref + "=" + _this.currentLang + window.location.hash);
                        } else {
                            window.history.replaceState(null, null, replaceHref + "&" + get_pref + "=" + _this.currentLang + window.location.hash);
                        }
                        _this.urlParams[get_pref] = _this.currentLang;
                    } 
                }                                     
            }
        }    
    }, 
  
    priceonhover: {
      
        init: function() {
            
            var _this = LS.localization;
            if( _this.defaultCurrOnHover == "1" && _this.switchersStyleSets && "defaultCurrHoverStyles" in _this.switchersStyleSets ) {

                var css = "",
                    head = document.head || document.getElementsByTagName('head')[0],
                    style = document.createElement('style'),
                    styleSet = _this.switchersStyleSets.defaultCurrHoverStyles,
                    font_size = ( styleSet.font_size ) ? styleSet.font_size : "14",
                    top_size = Math.ceil( ( parseInt( font_size, 10 ) + 10 ) / 2 );

                css += "body *:hover>.LS_converted_currencies.LS_show_on_hover:after { top: calc(50% - " + top_size + "px)!important; background: " + styleSet.background_color + "!important; font-size: " + font_size + "px!important; color: " + styleSet.font_color + "!important; }";
                css += "body *:hover>.LS_converted_currencies.LS_show_on_hover:before { border-right: 5px solid " + styleSet.background_color + "!important; }";

                style.type = 'text/css';
                if (style.styleSheet){
                    style.styleSheet.cssText = css;
                } else {
                    style.appendChild(document.createTextNode(css));
                }

                head.appendChild(style);
            }
        }
    }
}


/* Callback for "Quick View by Secomapp" */
if( typeof sca_default_callback_function != 'function' ) {
    function sca_default_callback_function ($,product) {
        if( product && typeof LS_global_product_object == "object" && product.handle in LS_global_product_object ) {
            
            var getProduct = LS_global_product_object[product.handle].product,
                titleElement = document.getElementById('sca-qv-title'),
                descrElement = document.getElementById('sca-qv-des'),
                priceElement = document.querySelector('#sca-qv-price-container .sca-qv-product-price'),
                variantsElement = document.getElementById('sca-qv-variant-options');
            
            if( titleElement ) {
                titleElement.innerHTML = "<strong>" + LS_global_product_object[product.handle].title + "</strong>";
            }
          
            if( descrElement ) {
                descrElement.innerHTML = LS_global_product_object[product.handle].description;
            }
          
            if( priceElement ) {
                var priceHTML = LS.localization.formatMoney(product.price);
                if( product.compare_at_price && product.compare_at_price > product.price ) {
                    priceHTML += "<del class='sca-qv-product-compare-price'>" + LS.localization.formatMoney(product.compare_at_price) + "</del>";
                }
                priceElement.innerHTML = priceHTML;
            }

            if( variantsElement ) {
                var selDropdown = variantsElement.querySelectorAll('.single-option-selector');
                if( selDropdown.length ) {
                    [].forEach.call(selDropdown, function(el) {
                        var optionName = el.getAttribute('data-option');
                        switch(optionName) {
                            case "option1": var optionIndex = 0; break;
                            case "option2": var optionIndex = 1; break;
                            case "option3": var optionIndex = 2; break;
                        }

                        if( typeof optionIndex != 'undefined' && getProduct.options[optionIndex] && el.previousSibling ) {
                            el.previousSibling.innerHTML = getProduct.options[optionIndex];
                            var selOptionLength = el.options.length;
                            if( selOptionLength ) {
                                for( var i = 0; i < selOptionLength; i++ ) {
                                    var optionTitle = el[i].innerText;
                                    for( var index in getProduct.variants ){
                                        var needle = getProduct.variants[index].options.indexOf(optionTitle);
                                        if( needle >= 0 ) {
                                            var translatedTitle = getProduct.variants[index]['option' + (needle + 1)];
                                            if( translatedTitle ) el[i].innerText = translatedTitle;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    });
                }
            }
        }
    }
}